var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const footballImport = () => __awaiter(void 0, void 0, void 0, function* () { return yield import('./football/index.js'); });
const rugbyLeagueImport = () => __awaiter(void 0, void 0, void 0, function* () { return yield import('./rugbyLeague/index.js'); });
const importFunction = {
    football: footballImport,
    rugbyLeague: rugbyLeagueImport
};
const loadSport = (sportName) => __awaiter(void 0, void 0, void 0, function* () { return importFunction[sportName](); });
export const Theme = {
    loadSport
};
export * from './utils/ads';
export * from './utils/components/Background';
export * from './utils/components/Graphic';
export * from './utils/components/Watermark/MaxAreaWatermark';
export * from './utils/useGsapLagSmoothingHideOnPageVisibility';
//# sourceMappingURL=index.js.map